// extracted by mini-css-extract-plugin
module.exports = {"message":"SupportForm_message__1sTqv","messageTextArea":"SupportForm_messageTextArea__14DZM","dropDownWrapper":"SupportForm_dropDownWrapper__3q2hE"};